export default __webpack_public_path__ + "static/media/PipeSupportWallHole.256.72584aa8.png";